import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../core/security/auth.guard';
import { AgingComponent } from '@app/modules/aging/components/aging/aging.component';
import { AgingSummaryHomeComponent } from '@modules/aging/components/aging-summary/components/aging-summary-home/aging-summary-home.component';
import { AgingNotSubscribedComponent } from '@modules/aging/components/aging-not-subscribed/aging-not-subscribed.component';
import { AgingSubscribedGuard } from '@modules/aging/guards/aging-subscribed.guard';

const routes: Routes = [
    {
        path: '',
        runGuardsAndResolvers: 'always',
        canActivate: [AuthGuard, AgingSubscribedGuard],
        component: AgingComponent,
        children: [
            {
                path: 'summary',
                component: AgingSummaryHomeComponent,
            },
            {
                path: 'worklist',
                loadChildren: () =>
                    import(
                        '../aging/modules/aging-worklist/aging-worklist.module'
                    ).then((module) => module.AgingWorklistModule),
            },
            {
                path: 'claims',
                loadChildren: () =>
                    import(
                        '../claims/modules/claims-home/claims-home.module'
                    ).then((m) => m.ClaimsHomeModule),
            },
            {
                path: 'details',
                loadChildren: () =>
                    import('./modules/aging-details/aging-details.module').then(
                        (m) => m.AgingDetailsModule,
                    ),
            },
            {
                path: 'uploadClaims',
                loadChildren: () =>
                    import(
                        '../claims/modules/upload-claims/upload-claims.module'
                    ).then((m) => m.UploadClaimsModule),
            },
            {
                path: 'claimPreviews',
                loadChildren: () =>
                    import(
                        '../claims/modules/claim-previews/claim-previews.module'
                    ).then((m) => m.ClaimPreviewsModule),
            },
            {
                path: 'insights',
                loadChildren: () =>
                    import(
                        './modules/aging-insights/aging-insights.routes'
                    ).then((r) => r.AgingInsightsRoutes),
            },
            {
                path: 'unassignedPayers',
                loadChildren: () =>
                    import(
                        './modules/unassigned-claim-payers/unassigned-payers.routes'
                    ).then((r) => r.UnassignedPayerRoutes),
            },
        ],
    },
    {
        path: 'notSubscribed',
        component: AgingNotSubscribedComponent,
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class AgingRoutingModule {}
